import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/index.js";
const app = createApp(App);

import lodash from "lodash";
window._ = lodash;

import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
app.use(ElementPlus);
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

import Antd from "ant-design-vue";
import "ant-design-vue/dist/reset.css";
import * as AntdIcons from "@ant-design/icons-vue";
app.use(Antd);
Object.keys(AntdIcons).forEach((key) => {
  if (key === "default") return;
  app.component(key, AntdIcons[key]);
});

import qs from "qs";
app.config.globalProperties.$qs = qs;
import axios from "./axios.js";
app.config.globalProperties.$axios = axios;
//组件复用
app.mixin({
  setup() {},
  methods: {
    errorMsgBox(notice) {
      // this.$message({
      //   message: notice,
      //   type: "error",
      // });

      this.$notify.error({
        title: "错误",
        message: notice,
      });
    },
    successMsgBox(notice) {
      if (!notice) {
        notice = "成功";
      }
      // this.$message({
      //   message: notice,
      //   type: "success",
      // });

      this.$notify({
        title: "提示",
        message: notice,
      });
    },
    //form表单提交，参数不用转换，自动修改头
    formDataApi(data, api) {
      return async () => {
        let res = null;
        try {
          res = await axios.post(api, data);
          res = res.data;
          return res;
        } catch (e) {
          this.$message({
            message: e.message,
            type: "error",
          });
          if (_.isFunction(error)) {
            await error(e);
          }
          return defaultValue;
        }
      };
    },
    apiAll(data, api, config = {}) {
      //1、默认api
      if (!api) {
        api = window.http;
      }
      //2、上传地址时使用心得content-type

      if (api == "/newHuiyiUpload") {
        //文件上传头Content-Type
        axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
      } else {
        //默认头Content-Type
        axios.defaults.headers.post["Content-Type"] =
          "application/x-www-form-urlencoded";
      }
      //3、默认空参数
      if (!data) {
        const params = {};
        data.params = JSON.stringify(params);
      }
      let qsParam = qs.stringify(data);
      return async () => {
        const { method = "POST", error, defaultValue = null } = config;
        let res = null;
        try {
          if (method.toUpperCase() === "GET") {
            res = await axios.get(api, {
              params: qsParam,
            });
          } else {
            res = await axios.post(api, qsParam);
          }
          res = res.data;
          return res;
        } catch (e) {
          this.$message({
            message: e.message,
            type: "error",
          });
          if (_.isFunction(error)) {
            await error(e);
          }
          return defaultValue;
        }
      };
    },
    async withLoading(asyncFunc) {
      let res = null;
      try {
        res = await asyncFunc();
      } catch (e) {
        console.error("WithLoading Error: ", e);
      }
      return res;
    },
  },
});
app.use(router).mount("#app");
